module.exports = __webpack_public_path__ + "img/FI14396050.e9e771ea.png";